import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["preview", "input", "submit", "template", "spinner"];

  previewImage(event) {
    const file = event.target.files[0]; // Always gets the right file input

    if (file) {
      this.spinnerTarget.classList.remove("hidden");

      const reader = new FileReader();
      reader.onload = (event) => {
        const template = this.templateTarget.content.cloneNode(true);
        template.querySelector("img").src = event.target.result;
        this.previewTarget.innerHTML = "";
        this.previewTarget.appendChild(template);
        this.spinnerTarget.classList.add("hidden");
      };

      reader.readAsDataURL(file);
    }
  }

  triggerFileInputClick() {
    this.inputTarget.click();
  }
}
